import { ChecklistItem } from "."

export const UnlimitedFiles = ({ forConfirmed }) => {
    return <ChecklistItem forConfirmed={forConfirmed}>Create unlimited sitemaps and user flows</ChecklistItem>    
}